export default "__VITE_ASSET__a90a8244__"